import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../services/user.service';
import {TitleCasePipe, NgIf} from '@angular/common';
import {FormService} from '../../../services/form.service';
import {ServerResponse} from '../../../models/server-response.model';
import {Route, Token} from '../../../utils/constant';
import {Router} from '@angular/router';
import {isObject} from 'util';


@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  loader = false;
  credential = {
    email: '',
    password: '',
    appVersion : 'V2'
  };
  _formErrors: any = {};
  form: FormGroup; 
  appRouts = Route;

  constructor(private titlecase: TitleCasePipe,
              private formService: FormService,
              private userService: UserService,
              private router: Router) {
  }

  ngOnInit() {
    this._resetFormErrors();
    this.form = new FormGroup({
      email: new FormControl(this.credential.email, [Validators.required]),
      password: new FormControl(this.credential.password, [Validators.required]),
      appVersion: new FormControl(this.credential.appVersion)
    });
  }

  private _resetFormErrors(): void {
    for (const credentialKey in this.credential) {
      if (this.credential.hasOwnProperty(credentialKey)) {
        this._formErrors[credentialKey] = {valid: true, message: ''};
      }
    }
  }

  onSubmit() {
    this.loader = true;
    if (!this.form.invalid) {
      this.userService.login(this.form.value).subscribe((response: ServerResponse) => {
          // console.log(response);
          if (response.error === 0 && response.authError === 0) {
            // console.log(Token.userToken);
            localStorage.removeItem(Token.webuserToken);
            localStorage.setItem('userSignInEmail', response.data.email);
            localStorage.setItem(Token.userToken, response.data.token);
            localStorage.setItem('role', response.data.role); 
          if(response.data.role =="Assistant")
          {
            this.router.navigate(['/' + Route.organizations]).catch(reason => {
              console.log('error.message', reason);
            });
          }
          else
          {
            this.router.navigate(['/' + Route.default]).catch(reason => {
              console.log('error.message', reason);
              
            });
          }
          } else if (response.authError === 1) {
            this.loader = false;
            localStorage.clear();
            this.router.navigate(['/' + Route.login]);
          } else if (response.error > 0) {
            if (isObject(response.msg)) {
              for (const msgKey in response.msg) {
                if (response.msg.hasOwnProperty(msgKey)) {
                  this.form.get(msgKey).setErrors({server: true, msg: response.msg[msgKey][0]});
                  console.log('error in auth');
                }
              }
              this.loader = false;
            } else {
              this.form.get('password').setErrors({server: true, msg: response.msg});
              this.loader = false;
            }
          }
        },
        error => {
          console.log('error.message', error.message);
        });
    } else {
      this.loader = false;
      this.formService.validateAllFormFields(this.form);
      return false;
    }
  }

  hasError(field): boolean {
    if (this.form.get(field).invalid && this.form.get(field).touched) {
      let msg = '';
      if (this.form.get(field).errors.required) {
        msg = this.titlecase.transform(field.replace('_', ' ')) + ' cannot be blank.';
      } else if (this.form.get(field).errors.email) {
        msg = 'Email is invalid.';
      } else if (this.form.get(field).errors.Equal) {
        msg = 'Password Mismatch.';
      } else if (this.form.get(field).errors.server) {
        msg = this.form.get(field).errors.msg;
      }
      this._formErrors[field] = {valid: false, message: msg};
    } else {
      this._formErrors[field] = {valid: true, message: ''};
    }
    return !this._formErrors[field].valid;
  }


}
